import declare from "dojo/_base/declare";
import StateActionController from "csi/breadcrumb/StateActionController";
import csiView from "csi/view";
import _ApproveBOMMixin from "./_ApproveBOMMixin";
const PhaseFreezeController = declare([StateActionController, _ApproveBOMMixin], {
	/**
	* @override
	* redraw view after validation
	*/
	onRefreshValidation() {
		csiView.getView("PartMaterials").refreshData();
	},
});
export = PhaseFreezeController;


